'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React from 'react';
import { defineMessages } from 'react-intl';
export const projectMenuMessages = defineMessages({
    pin: {
        defaultMessage: 'Pin project',
        description: 'Menu item to pin a space to the sidebar when spaces are rebranded as projects',
        id: '0abb8aa51f',
    },
    unpin: {
        defaultMessage: 'Unpin project',
        description: 'Menu item to unpin a space from the sidebar when spaces are rebranded as projects',
        id: '61d2918a08',
    },
    leave: {
        defaultMessage: 'Leave project',
        description: 'Menu item to leave a space the user is a contributor of when spaces are rebranded as projects',
        id: '041ec525d2',
    },
    delete: {
        defaultMessage: 'Delete project',
        description: 'Menu item to delete a space from the header dropdown when spaces are rebranded as projects',
        id: 'f1a8591b65',
    },
});
export function renderProjectMenuItems(state, components, translate, onActionSelect, { showPinAction = true } = {}) {
    const { Item, Separator } = components;
    const hasActionBeforeDelete = (showPinAction && state.isUserLoggedIn) || state.canLeave;
    return (_jsxs(_Fragment, { children: [showPinAction && state.isUserLoggedIn && (_jsx(Item, { leadingAccessory: state.isPinned ? $icon('pinned-off') : $icon('pin'), onSelect: () => {
                    onActionSelect?.(state.isPinned ? 'unpin' : 'pin');
                    state.handlePinToggle();
                }, children: translate(state.isPinned ? projectMenuMessages.unpin : projectMenuMessages.pin) })), state.canLeave && (_jsx(Item, { leadingAccessory: $icon('logout'), onSelect: () => {
                    onActionSelect?.('leave');
                    state.handleLeaveSpace();
                }, children: translate(projectMenuMessages.leave) })), state.isOwner && (_jsxs(_Fragment, { children: [hasActionBeforeDelete && _jsx(Separator, {}), _jsx(Item, { leadingAccessory: $icon('trash'), onSelect: () => {
                            onActionSelect?.('delete');
                            state.handleDeleteSpace();
                        }, textValue: "delete", variant: "negative", children: translate(projectMenuMessages.delete) })] }))] }));
}
//# sourceMappingURL=ProjectMenuItems.js.map